<app-topnav></app-topnav>


<!-- HEADER -->
<app-header-secondary-b  [pageTitle]="'inscription.title' | translate" 
[pageDescription]="'inscription.description' | translate"></app-header-secondary-b>
<!-- end HEADER -->

<section  id="section-inscription" *ngIf="currentLang ==='fr'">
    <div class="container" id="section-inscription-inner">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-12">
                    <P>Si vous êtes un client de Plurilogic et n'avez pas de mot de passe pour accéder la section des utilisateurs, simplement remplir le formulaire suivant :</P>
                </div>
            </div>
        </div>       
    </div>
</section>

<section  id="section-inscription" *ngIf="currentLang ==='en'">
    <div class="container" id="section-inscription-inner">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-12">
                    <P>If you are a Plurilogic customer and do not have a password to access the user section, simply fill out the following form:</P>
                </div>
            </div>
        </div>
    </div>
</section>

<section  id="section-inscription-form">
    <div class="container">
        
        <table class="TableauCentre">
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.nom' | translate }}*</td>
            <td class="TableauEntreeInfo"><input [(ngModel)]="nom" type="text" size="35" maxlength="49" name="Nom" value=""></td>
        </tr>
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.prenom' | translate }}*</td>
            <td class="TableauEntreeInfo"><input [(ngModel)]="prenom" type="text" size="35" maxlength="49" name="Prenom" value=""></td>
        </tr>
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.courriel' | translate }}*</td>
            <td class="TableauEntreeInfo"><input [(ngModel)]="courriel" type="text" size="35" maxlength="99" name="Courriel" value=""></td>
        </tr>
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.college' | translate }}*</td>
            <td class="TableauEntreeInfo"><input [(ngModel)]="college" type="text" size="35" maxlength="49" name="College" value=""></td>
        </tr>
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.profession' | translate }}*</td>
            <td class="TableauEntreeInfo"><input [(ngModel)]="profession" type="text" size="35" maxlength="100" name="Profession" value=""></td>
        </tr>
        <tr>
            <td class="TableauEntreeInfoEntete" valign="top">{{ 'formInscr.logiciels' | translate }}*</td>
            <td class="TableauEntreeInfo">

                <table class="TableauListeTexte" cellpadding="0" cellspacing="0">
                    <tr>
                        <td><input [(ngModel)]="progFGF" type="checkbox" name="FGF" value="1" ></td>
                        <td>&nbsp;FGF</td>
                        <td width="16"></td>
                        <td><input [(ngModel)]="progFGP" type="checkbox" name="FGP" value="1" ></td>
                        <td>&nbsp;FGP</td>
                        <td width="16"></td>
                        <td><input [(ngModel)]="progFGB" type="checkbox" name="FGB" value="1" ></td>
                        <td>&nbsp;FGB</td>
                        <td width="16"></td>
                        <td><input [(ngModel)]="progFGI" type="checkbox" name="FGI" value="1" ></td>
                        <td>&nbsp;FGI</td>
                        <td width="16"></td>
                        <td><input [(ngModel)]="progPP2" type="checkbox" name="PP2" value="1" ></td>
                        <td>&nbsp;Pluriportail</td>
                    </tr>
                </table>
            
                {{ 'formInscr.autres' | translate }} : <input [(ngModel)]="progAutres" type="text" size="29" maxlength="100" name="Logiciels" value="">
            </td>
        </tr>
        <tr>
            <td colspan="2" class="TableauEntreeLigneBouton" valign="top"><button class="envoyer btn btn-outline-light" (click)="btnEnvoyerClick()">{{ 'formInscr.envoyer' | translate }}</button></td>
        </tr>
    </table>
    </div>
</section>


<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>
